import React, { useState, useEffect } from "react";

// Remplacez ces constantes par les infos réelles de l'école
const CONTACT_EMAIL = "contact.ecole.lolivier@gmail.com";
const CONTACT_ADDRESS = "5 Bd Giraud, 13014 Marseille";
const LAST_UPDATED = "octobre 2025";

export default function PolitiqueRGPD() {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem("rgpd_cookie_dismissed");
      if (!dismissed) setShowCookieBanner(true);
    } catch (e) {
      // localStorage peut être bloqué ; afficher la bannière par défaut
      setShowCookieBanner(true);
    }
  }, []);

  const dismissBanner = () => {
    try {
      localStorage.setItem("rgpd_cookie_dismissed", "1");
    } catch (e) {
      // ignore
    }
    setShowCookieBanner(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 py-10 px-4 sm:px-6 lg:px-24">
      <article className="max-w-4xl mx-auto bg-white shadow-md rounded-2xl p-8 md:p-12">
        <header className="mb-8">
          <h1 className="text-3xl md:text-4xl font-extrabold">Politique de confidentialité (RGPD)</h1>
          <p className="mt-2 text-sm text-gray-500">Dernière mise à jour : {LAST_UPDATED}</p>
        </header>

        <section className="space-y-6">
          <p>
            L’école <strong>L’Olivier</strong> attache une grande importance à la protection des données personnelles. Cette
            page explique quelles données peuvent être collectées, pourquoi, et comment vous pouvez exercer vos droits.
          </p>

          <div>
            <h2 className="text-xl font-semibold">1. Responsable du traitement</h2>
            <p className="mt-2 text-sm text-gray-700">
              Responsable : <strong>École L’Olivier</strong>
              <br />
              Adresse : <span className="italic">{CONTACT_ADDRESS}</span>
              <br />
              Contact : <a className="text-blue-600 hover:underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">2. Données collectées</h2>
            <p className="mt-2 text-sm text-gray-700">
              Le site est à vocation informative et ne propose pas d’espace élève ni d’inscription en ligne. Aucune
              collecte automatique de données personnelles (comptes, inscriptions, etc.) n’est effectuée.
            </p>
            <p className="mt-2 text-sm text-gray-700">
              Les seules données susceptibles d’être transmises volontairement par les visiteurs sont celles renseignées
              via le formulaire de contact : nom, adresse e-mail et contenu du message. Ces informations sont envoyées vers la boîte Gmail de l’école afin de permettre le traitement des demandes.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">3. Finalités</h2>
            <p className="mt-2 text-sm text-gray-700">
              Les données transmises via le formulaire servent uniquement à répondre aux messages et à assurer le suivi
              des demandes d’information relatives à l’école. Aucune utilisation commerciale ni transmission à des tiers
              à des fins commerciales n’est effectuée.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">4. Base légale</h2>
            <p className="mt-2 text-sm text-gray-700">Le traitement repose sur le consentement explicite de l’utilisateur lorsqu’il envoie un message via le formulaire (article 6.1.a du RGPD).</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">5. Durée de conservation</h2>
            <p className="mt-2 text-sm text-gray-700">
              Les messages reçus sont conservés le temps nécessaire au traitement des demandes. Ils sont ensuite
              supprimés régulièrement de la boîte Gmail de l’école.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">6. Hébergement</h2>
            <p className="mt-2 text-sm text-gray-700">
              Le site est hébergé par <strong>Netlify, Inc.</strong>. Les contenus sont servis depuis l’infrastructure de
              Netlify. Netlify propose des engagements de conformité au RGPD et met en œuvre des mesures de sécurité
              adaptées.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">7. Services tiers</h2>
            <p className="mt-2 text-sm text-gray-700">
              Le site peut intégrer des vidéos YouTube externes. En visualisant ces vidéos, Google/YouTube peut déposer
              des cookies indépendants du site et collecter des données de navigation.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">8. Cookies</h2>
            <p className="mt-2 text-sm text-gray-700">
              Le site n’utilise pas de cookies de suivi ou d’analyse propriétaires. Seuls des cookies techniques peuvent
              être déposés par des services tiers intégrés, principalement YouTube lors de la lecture de vidéos.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">9. Droits des personnes</h2>
            <p className="mt-2 text-sm text-gray-700">
              Conformément au RGPD, vous disposez d’un droit d’accès, de rectification, d’effacement, d’opposition et de
              limitation du traitement de vos données. Pour exercer ces droits, contactez-nous par e-mail à
              <a className="text-blue-600 hover:underline ml-1" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">10. Sécurité</h2>
            <p className="mt-2 text-sm text-gray-700">
              L’école met en œuvre des mesures raisonnables pour protéger les données transmises (sécurité de la boîte
              mail, bonnes pratiques, mots de passe, etc.). Les messages sont gérés via Gmail/Google qui applique des
              protections complémentaires.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">11. Contact et réclamations</h2>
            <p className="mt-2 text-sm text-gray-700">
              Pour toute question sur la protection des données : <a className="text-blue-600 hover:underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </p>
            <p className="mt-2 text-sm text-gray-500">Vous pouvez également saisir la CNIL si vous estimez que vos droits ne sont pas respectés.</p>
          </div>

          <footer className="mt-8 pt-6 border-t border-gray-100">
            <p className="text-sm text-gray-500">© École L’Olivier — Politique de confidentialité • Hébergé par Netlify</p>
          </footer>
        </section>
      </article>

      {/* Cookie banner (simple, informatif) */}
      {showCookieBanner && (
        <div className="fixed left-4 right-4 bottom-6 sm:left-auto sm:right-12 sm:bottom-8 z-50">
          <div className="max-w-2xl mx-auto bg-white shadow-lg rounded-xl p-4 md:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1 text-sm text-gray-700">
              Ce site n’utilise pas de cookies de suivi. Certaines vidéos YouTube intégrées peuvent déposer des cookies
              techniques ou publicitaires gérés par Google/YouTube.
            </div>
            <div className="flex-shrink-0">
              <button
                onClick={dismissBanner}
                className="inline-flex items-center justify-center px-4 py-2 rounded-lg font-medium bg-vertLogo text-white"
              >
                J'ai compris
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
